module.exports = __webpack_public_path__ + "img/Icn_play.52a709a2.svg";